<!-- 报警 -->
<template>
  <div class="app-container">
    <div class="app-content">
      <el-card class="meter-alarm__card" shadow="never">
        <template #header>
          <el-form inline size="small">
            <el-form-item :label="$t('text.sblx')">
              <el-select v-model="queryParams.devtype" placeholder="">
                <el-option
                  v-for="item in devtypes"
                  :key="item.key"
                  :value="item.value"
                  :label="$t(item.key)"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('text.kssj')">
              <el-date-picker
                v-model="queryParams.starttime"
                type="date"
                clearable
                :placeholder="$t('placeholder.kssj')"
                value-format="yyyy-MM-dd 00:00:00"
              />
            </el-form-item>
            <el-form-item :label="$t('text.jssj')">
              <el-date-picker
                v-model="queryParams.endtime"
                type="date"
                :placeholder="$t('placeholder.jssj')"
                value-format="yyyy-MM-dd 23:59:59"
              />
            </el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              size="small"
              :loading="table.loading"
              @click="handelQuery"
            >{{ $t('button.cx') }}</el-button>
          </el-form>
        </template>
        <template #default>
          <el-table
            v-loading="table.loading"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            height="calc(100% - 50px)"
            :data="table.data"
          >
            <el-table-column
              :label="$t('text.xh')"
              type="index"
              :index="indexCount"
              width="90"
            />
            <el-table-column
              :label="$t('text.rq')"
              width="150"
              prop="createtime"
            >
              <template v-slot="scope">
                <span>{{ scope.row.createtime | dateFilter('yyyy-MM-dd hh:mm:ss') }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('text.cjqsn')"
              prop="gatewaysn"
            />
            <el-table-column
              :label="$t('text.nbqsn')"
              prop="sn"
            />
            <el-table-column
              :label="$t('text.sblx')"
            >
              <template v-slot="scope">
                <span>{{ scope.row.devtype==='0' ?$t('text.zc'):scope.row.devtype==='1'?$t('text.cn'):scope.row.devtype==='2'?$t('text.qx'):$t('text.db') }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('text.bjlx')"
              prop="alarmdesc"
            />
            <el-table-column
              :label="$t('text.bjzt')"
              prop="status"
              :formatter="$alarmStatus"
            />
            <el-table-column
              :label="$t('text.cz')"
            >
              <template v-slot="scope">
                <el-button
                  v-if="scope.row.status === '0'"
                  type="text"
                  icon="el-icon-check"
                  size="small"
                  @click="handleDispose(scope.row)"
                >{{ $t('button.cl') }}</el-button>
                <el-button
                  type="text"
                  class="danger"
                  icon="el-icon-delete"
                  size="small"
                  @click="handleDelete(scope.row)"
                >{{ $t('button.sc') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            :current-page.sync="page.pageNum"
            :page-size="page.pageSize"
            :total="page.total"
            background
            layout="prev, pager, next"
            size="small"
            @current-change="getTableData"
          />
        </template>
      </el-card>
    </div>
  </div>
</template>

<script>
import { QueryAlarms, HandleAlarm, BatchDelAlarms } from '@apis/Alarms'
export default {
  data () {
    return {
      queryParams: {
        orgid: this.$store.getters.station.id,
        devtype: '3'
      },
      devtypes: [
        { key: 'text.zc', value: '0' },
        { key: 'text.cn', value: '1' },
        { key: 'text.qx', value: '2' },
        { key: 'text.db', value: '3' },
      ],
      table: {
        loading: false,
        data: []
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      }
    }
  },
  created () {
    this.getTableData()
  },
  methods: {
    // 序号
    indexCount (index) {
      return (this.page.pageNum - 1) * this.page.pageSize + (index + 1)
    },
    // 查询
    handelQuery () {
      this.page.pageNum = 1
      this.getTableData()
    },
    // 获取表格数据
    getTableData () {
      this.table.loading = true
      QueryAlarms({
        page: this.page.pageNum,
        perPage: this.page.pageSize,
        orderBy: 'createtime desc',
        whereCondition: JSON.stringify(this.queryParams)
      }).then(res => {
        this.table.data = res.data.queryResults
        this.page.total = res.data.totalCount
        this.table.loading = false
      }).catch(() => {
        this.table.loading = false
      })
    },
    // 处理报警
    handleDispose (row) {
      this.$confirm(this.$t('notice.sfcl'), this.$t('notice.title'), {
        confirmButtonText: this.$t('button.qr'),
        cancelButtonText: this.$t('button.qx'),
      }).then(() => {
        return HandleAlarm({ id: row.id })
      }).then(() => {
        this.$msgSuccess(this.$t('notice.clcg'))
        this.handleQuery()
      }).catch(() => {
        this.$msgInfo(this.$t('notice.qxcl'))
      })
    },
    // 删除报警
    handleDelete (row) {
      this.$confirm(this.$t('notice.sfsc'), this.$t('notice.title'), {
        confirmButtonText: this.$t('button.qr'),
        cancelButtonText: this.$t('button.qx'),
        type: 'warning'
      }).then(() => {
        return BatchDelAlarms({ ids: [row.id] })
      }).then(() => {
        this.$msgSuccess(this.$t('notice.sccg'))
        this.handleQuery()
      }).catch(() => {
        this.$msgInfo(this.$t('notice.qxsc'))
      })
    }
  }
}
</script>
<style scoped>
.meter-alarm__card {
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: var(--card-bg-color);
  border-color: var(--card-bg-color);
}
.meter-alarm__card >>> .el-card__header {
  width: 100%;
  height: 50px;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.meter-alarm__card >>> .el-card__header .el-form-item {
  margin-bottom: 0;
}

.meter-alarm__card >>> .el-card__body {
  width: 100%;
  height: calc(100% - 50px);
  padding: 0;
  box-sizing: border-box;
}

.meter-alarm__card >>> .el-card__body .el-pagination {
  width: 100%;
  height: 50px;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>

